export const data = {
  PHONE: '1 (809) 736.9236',
  ADDRESS: 'Parque industrial Gurabo Nave #10, Avenida Gregorio Luperón km 6, Santiago De Los Caballeros 51000, Dominican Republic',
  EMAIL: 'info@alsackco.com',
  OPERATING: '8:00Am - 5:45pm'
}